// extracted by mini-css-extract-plugin
export default {"infinite-loader":"styles_infinite-loader__vsyzH","bounce":"styles_bounce__VB1fF","in-view":"styles_in-view__131Pt"};